module.exports = __webpack_public_path__ + "res/slot.09338ae465740a043418230636fe1fcd.webp";